import {useSnackbar} from 'notistack';
import React from 'react';
import {BackButton} from '../../Components/Buttons/BackButton';
import {CardContainer} from '../../Components/CardContainer/CardContainer';
import {CreateAndUpdateForm} from '../../Components/FormGenerators/CreateAndUpdateForm';
import {
  createEmptyEditableSchool,
  IEditableSchool,
} from '../../Components/FormGenerators/IEditableSchool';
import {removeLastEmptyEntityTag} from '../../Components/FormGenerators/Inputs/SubjectClassField/EntityTag';
import {RowOfButtons} from '../../Components/Layout/RowOfButtons';
import PageTitle from '../../Components/PageTitle/PageTitle';
import {LMessages} from '../../Localization/Localization';
import {IPageInterface} from '../entity/IPageInterface';
import {SchoolUpdateFields} from './SchoolFields';

/**
 * School's Create card.
 * @return {JSX.Element}
 * @constructor
 */
export default function SchoolCCard({}: IPageInterface) {
  const emptyEntity: IEditableSchool = createEmptyEditableSchool();

  const {enqueueSnackbar} = useSnackbar();

  return (
    <React.Fragment>

      <PageTitle title={LMessages.SCHOOL_C_CARD_TITLE}/>

      <RowOfButtons>
        <BackButton/>
      </RowOfButtons>

      <CardContainer>
        <CreateAndUpdateForm<IEditableSchool>
          action={'SCHOOL_CREATE'}
          fields={SchoolUpdateFields}
          data={emptyEntity}
          snackBar={enqueueSnackbar}
          preProcessData={removeLastEmptyEntityTag}
        />
      </CardContainer>
    </React.Fragment>
  );
};
